import React from "react";
import alertIcon from "../../Assets/icon/alertIconNew.png";
import internetIcon from "../../Assets/icon/internetIcon.png";
import uploadIcon from "../../Assets/icon/uploadIconNew.png";
import {Box} from "@mui/material";

export default function AlertIcon(props: any){
    const renderSwitch = (param: any) => {
        switch(param) {
            case 'reTryWarning':
                return internetIcon;
            case 'alert':
                return alertIcon;
            case 'maxTry':
                return alertIcon;
            case 'notCameraSupport':
                return alertIcon;
            case 'noFaceDetected':
                return alertIcon;
            case 'severalFaces':
                return alertIcon;
            case 'farFace':
                return alertIcon;
            case 'complete':
                return uploadIcon;
            case 'mismatch':
                return uploadIcon;
            case 'editPersonalInfo':
                return alertIcon;
            default:
                return '';
        }
    }
    return (
        <>
            <Box
                style={{ width: '100%', maxWidth: '120px' }}
                component="img"
                sx={{

                }}
                alt=""
                src={renderSwitch(props.value)}
            />
        </>
    )
}
